<template>
  <div class="avatar-and-name">
    <CustomerAvatar :size="size" :customer-id="customerId"></CustomerAvatar>
    <a v-if="linkToCustomer" :href="customerDashboardURI"><p class="color-primary m-0">{{ name }}</p></a>
    <span v-else style="white-space: nowrap"> {{ name }} </span>
  </div>


</template>

<script>
export default {
  name: "CustomerAvatarAndName.vue",
  props: {
    size: {
      required: false,
    },
    customerId: {
      required: false,
    },
    name: {
      required: true,
    },
    linkToCustomer:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    customerDashboardURI () {
      return '/customer/' + this.customerId + '/dashboard'
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.avatar-and-name {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: $spacing-xs;
}
</style>